import * as React from 'react';

import {getDisplayName} from 'nutshell-core/utils';

import type {ReportSegment, ODRReportData} from '../report-types';

type MakeChartClickableProps = {
    segment: ReportSegment;
    onClickChart?: (arg1: ReportSegment, arg2: ODRReportData) => any;
    data?: Array<any>;
    exportReportLink?: string;
};

export function makeChartClickable(WrappedChartComponent: React.ComponentType<any>) {
    return class HOC extends React.Component<MakeChartClickableProps> {
        static displayName = `HOC(${getDisplayName(WrappedChartComponent)})`;

        render() {
            return <WrappedChartComponent {...this.props} onClickChart={this.handleChartClick} />;
        }

        handleChartClick = () => {
            if (typeof this.props.onClickChart === 'function' && this.props.data) {
                const data: ODRReportData = {
                    chartData: this.props.data,
                    exportLink: this.props.exportReportLink,
                };
                this.props.onClickChart(this.props.segment, data);
            }
        };
    };
}
